import axios from "axios";
import { getApiConfig } from "./config.js";

export const APIGetDrivers = async (
  pageNumber,
  filters,
  setLoading,
  institutionId,
  searchTerm
) => {
  setLoading(true);

  try {
    const apiConfig = getApiConfig();
    const result = await axios.get(`${apiConfig.baseURL}/drivers`, {
      headers: apiConfig.headers,
      params: {
        page: pageNumber,
        totalPerPage: 10,
        institutionId: institutionId,
        searchKey: searchTerm,
        ...filters,
      },
    });
    return result;
  } catch (error) {
    console.error("Error fetching drivers:", error);
    return error;
  }
};

export const APICreateDriver = async (
  driverData,
  setLoading,
  institutionId,
  token
) => {
  setLoading(true);
  const apiConfig = getApiConfig();
  try {
    const formattedData = {
      ...driverData,
      institutionId: institutionId,
    };

    const result = await axios.post(
      `${apiConfig.baseURL}/drivers`,
      formattedData,
      {
        headers: {
          ...apiConfig.headers,
          token: token,
          institutionId: institutionId,
        },
      }
    );
    return result;
  } catch (error) {
    console.error("Error creating driver:", error);
    return error;
  }
};

export const APIUpdateDriver = async (
  driverData,
  setLoading,
  institutionId,
  token
) => {
  setLoading(true);
  const apiConfig = getApiConfig();

  try {
    const result = await axios.patch(
      `${apiConfig.baseURL}/drivers/`,
      driverData,
      {
        headers: {
          ...apiConfig.headers,
          token: token,
          institutionId: institutionId,
        },
      }
    );
    return result;
  } catch (error) {
    console.error("Error updating drivers:", error);
    return error;
  }
};

export const APIDeleteDriver = async (
  email,
  setLoading,
  institutionId,
  token
) => {
  setLoading(true);
  const apiConfig = getApiConfig();

  try {
    const result = await axios.delete(`${apiConfig.baseURL}/drivers`, {
      headers: {
        ...apiConfig.headers,
        token: token,
        institutionId: institutionId,
      },
      data: { email: email },
    });
    return result;
  } catch (error) {
    console.error("Error deleting driver:", error);
    return error;
  } finally {
    setLoading(false);
  }
};
